import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Column = _resolveComponent("Column")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_ctx.loaded && _ctx.getPropertyBooleanValue(_ctx.BaseControlTypeConst.VISIBLE))
    ? _withDirectives((_openBlock(), _createBlock(_component_Column, {
        key: 0,
        container: _ctx.container,
        id: _ctx.getPropertyValue(_ctx.ColumnTypeConst.ID),
        style: _normalizeStyle(_ctx.getPropertyValue(_ctx.ColumnTypeConst.STYLE)),
        class: _normalizeClass({ [_ctx.getPropertyValue(_ctx.ColumnTypeConst.CLASS) ?? '']: true, 'customrequired': _ctx.getPropertyBooleanValue(_ctx.ColumnTypeConst.REQUIRED) }),
        name: _ctx.getPropertyValue(_ctx.ColumnTypeConst.NAME),
        disabled: _ctx.getPropertyBooleanValue(_ctx.ColumnTypeConst.DISABLED),
        visible: _ctx.getPropertyBooleanValue(_ctx.ColumnTypeConst.VISIBLE),
        placeholder: _ctx.getPropertyValue(_ctx.ColumnTypeConst.PLACEHOLDER),
        field: _ctx.getPropertyValue(_ctx.ColumnTypeConst.FIELD),
        header: _ctx.getPropertyValue(_ctx.ColumnTypeConst.HEADER),
        sortable: _ctx.getPropertyBooleanValue(_ctx.ColumnTypeConst.SORTABLE),
        modelValue: _ctx.vmodel,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.vmodel) = $event))
      }, null, 8 /* PROPS */, ["container", "id", "style", "class", "name", "disabled", "visible", "placeholder", "field", "header", "sortable", "modelValue"])), [
        [_directive_tooltip, _ctx.getPropertyValue(_ctx.ColumnTypeConst.TOOLTIP)]
      ])
    : _createCommentVNode("v-if", true)
}